<template>
  <div class="page-content invoicePage">
    <div class="page-header d-flex d-flex-between d-flex-middle">
      <div class="page-title d-flex d-flex-middle">
        <span class="title-bar"></span>
        <span class="title-text">发票管理</span>
      </div>
    </div>

    <!-- <div class="search-box">
      <el-form :inline="true" :model="searchForm" class="demo-form-inline" size="small">
        <el-form-item label="助学年份">
          <el-select v-model="searchForm.yearTime" placeholder="请选择年份" clearable style="width: 140px;">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="year in yearOptions" :key="year" :label="'第' + year + '学年'" :value="year"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div> -->

    <div class="content" v-loading="listLoading">
      <div v-if="!listLoading && list.length == 0" class="empty-tip">暂无发票数据</div>
      <div class="invoice-list">
        <div class="invoice-item" v-for="item in list" :key="item.orderId || item.orderNo || item.id">
          <div class="invoice-info">
            <div class="info-row">
              <div class="info-item">
                <span class="label">费用类型：</span>
                <span class="value">第{{ item.yearTime }}学年助学培训费</span>
              </div>
              <div class="info-item">
                <span class="label">金额：</span>
                <span class="value money">¥{{ item.money }}</span>
              </div>
            </div>
            <div v-if="item.invoiceTime" class="info-row">
              <div class="info-item">
                <span class="label">开票时间：</span>
                <span class="value">{{ item.invoiceTime }}</span>
              </div>
            </div>
          </div>
          <div class="invoice-action">
            <el-button
              v-if="item.status === 'YZF' && item.orderId"
              type="primary"
              size="small"
              class="download-btn"
              :loading="fetchingInvoiceId === item.orderId"
              @click="handleFetchInvoice(item)"
            >下载发票</el-button>
            <el-tag v-if="item.money == '0'" type="success" size="small" class="status-tag">免费</el-tag>
            <el-tag v-if="item.status === 'WZF' && item.money > 0" type="info" size="small" class="status-tag">未缴费</el-tag>

          </div>
        </div>
      </div>
    </div>

    <div class="pagination-box" v-if="total > 0">
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="form.size"
        :total="total"
        :current-page="form.current"
        @current-change="changePage"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      listLoading: false,
      fetchingInvoiceId: null,
      form: {
        size: 10,
        current: 1,
      },
      searchForm: {
        yearTime: ''
      },
      total: 0,
      yearOptions: []
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    buildOrderQueryParams() {
      const params = {
        size: this.form.size,
        current: this.form.current
      }
      if (this.searchForm.yearTime !== '' && this.searchForm.yearTime != null) {
        params.yearTime = this.searchForm.yearTime
      }
      return params
    },
    getData() {
      this.listLoading = true
      this.$http
        .get('/student/pc/order/myOrders', this.buildOrderQueryParams())
        .then((res) => {
          this.list = res.records || []
          this.total = res.total != null ? res.total : 0
        })
        .catch(() => {
          this.list = []
          this.total = 0
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    handleFetchInvoice(item) {
      const orderId = item.orderId
      if (!orderId) {
        this.$message.warning('订单信息不完整，无法查询发票')
        return
      }
      this.fetchingInvoiceId = orderId
      this.$http
        .get(`/student/pc/getInvoice/${orderId}`)
        .then((url) => {
          if (url) {
            window.open(url)
          }
        })
        .catch(() => {})
        .finally(() => {
          this.fetchingInvoiceId = null
        })
    },
    handleSearch() {
      this.form.current = 1
      this.getData()
    },
    handleReset() {
      this.searchForm.yearTime = ''
      this.form.current = 1
      this.getData()
    },
    changePage(e) {
      this.form.current = e
      this.getData()
    }
  }
}
</script>

<style lang="scss" scoped>
.invoicePage {
  padding: 0 30px 30px;
  min-height: 500px;

  .page-header {
    height: 80px;
    line-height: 80px;
    padding: 0;
    border-bottom: none;

    .page-title {
      padding: 0;

      .title-bar {
        display: inline-block;
        width: 6px;
        height: 18px;
        background: linear-gradient(90deg, #1687DE 0%, #4084FF 100%);
        border-radius: 0;
        margin-right: 10px;
      }

      .title-text {
        font-size: 18px;
        font-weight: bold;
        color: #333;
      }
    }
  }

  .search-box {
    background: #fff;
    padding: 20px 24px;
    margin-bottom: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  }

  .content {
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
    min-height: 200px;
  }

  .empty-tip {
    text-align: center;
    padding: 80px 0;
    color: #999;
    font-size: 14px;
  }

  .invoice-list {
    padding: 0 24px;
  }

  .invoice-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 0;
    border-bottom: 1px solid #f0f2f5;
    transition: all 0.3s;

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      background: #fafafa;
      margin: 0 -24px;
      padding: 20px 24px;
    }

    .invoice-info {
      flex: 1;

      .info-row {
        display: flex;
        align-items: center;
        margin-bottom: 12px;

        &:last-child {
          margin-bottom: 0;
        }

        .info-item {
          display: flex;
          align-items: center;
          margin-right: 40px;

          .label {
            color: #909399;
            font-size: 14px;
            margin-right: 6px;
          }

          .value {
            color: #303133;
            font-size: 14px;

            &.money {
              color: #f56c6c;
              font-weight: 600;
              font-size: 16px;
            }
          }
        }
      }
    }

    .invoice-action {
      .download-btn {
        background: linear-gradient(90deg, #1687DE 0%, #4084FF 100%);
        border: none;
        padding: 8px 16px;
        border-radius: 4px;
        transition: all 0.3s;

        &:hover {
          background: linear-gradient(90deg, #4084FF 0%, #1687DE 100%);
          box-shadow: 0 4px 12px rgba(64, 132, 255, 0.3);
          transform: translateY(-1px);
        }
      }

      .status-tag {
        border-radius: 4px;
      }
    }
  }

  .pagination-box {
    margin-top: 20px;
    text-align: center;
    padding: 20px 0;
  }
}

::v-deep .el-form-item {
  margin-bottom: 0;
}

::v-deep .el-pagination{
  justify-content: center;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background: linear-gradient(90deg, #1687DE 0%, #4084FF 100%);
}
</style>
